import { PropsWithChildren } from "react";
import styles from "./TableColumnHeader.module.css";

type TableColumnHeaderProps = {
  center?: boolean;
  sortable?: boolean;
  isSorted?: boolean;
  isSortedDesc?: boolean;
};

const TableColumnHeader = ({
  sortable,
  isSorted,
  isSortedDesc,
  center,
  children,
}: PropsWithChildren<TableColumnHeaderProps>) => {
  return (
    <div
      className={`d-flex align-items-center ${
        center ? "justify-content-center" : ""
      }`}
    >
      {children}
      {sortable && (
        <>
          <span className="mx-sm"></span>
          <span
            className={
              isSorted
                ? isSortedDesc
                  ? styles.arrowDown
                  : styles.arrowUp
                : `${styles.arrowDown} ${styles.dummy}`
            }
          ></span>
        </>
      )}
    </div>
  );
};
export default TableColumnHeader;
